/**
 * Tableau 10 categorical color palette.
 *
 * Ten research-backed hues with uniform perceived brightness,
 * defined as CSS custom properties in globals.css (--t10-*-bg / --t10-*-text).
 */

const T10_NAMES = [
  'blue',
  'orange',
  'red',
  'teal',
  'green',
  'yellow',
  'purple',
  'pink',
  'brown',
  'gray',
] as const

export type T10Name = (typeof T10_NAMES)[number]

function nameAt(index: number): T10Name {
  return T10_NAMES[index % T10_NAMES.length] as T10Name
}

/** Inline style object for a Tableau 10 hue by color name. */
export function getT10StyleForName(name: T10Name): React.CSSProperties {
  return {
    backgroundColor: `var(--t10-${name}-bg)`,
    color: `var(--t10-${name}-text)`,
  }
}

/** Inline text color style for a Tableau 10 hue by color name. */
export function getT10TextStyleForName(name: T10Name): React.CSSProperties {
  return {
    color: `var(--t10-${name}-text)`,
  }
}

/** Inline style object for a Tableau 10 hue (badge bg + text). */
export function getT10Style(index: number): React.CSSProperties {
  return getT10StyleForName(nameAt(index))
}

/** Inline style for tag-style elements (bg + border, foreground text). */
export function getT10TagStyle(index: number): React.CSSProperties {
  const name = nameAt(index)
  return {
    backgroundColor: `var(--t10-${name}-bg)`,
    color: 'hsl(var(--foreground))',
    borderColor: `var(--t10-${name}-bg)`,
  }
}

/** Get the T10 name for an index (wraps around). */
export function getT10Name(index: number): T10Name {
  return nameAt(index)
}
